import $ from 'jquery';


// jQuery(document).ready(function($){
//     var $table = $('.locales');
//     var $rows = $table.find('article.tease-domy');
//     var $header = $('.loct__powl');

//     var originalOrder = $rows.toArray();
//     var sortState = 0; // 0 = normal, 1 = desc, 2 = asc

//     $header.on('click', function(){
//         $header.removeClass('sort-asc sort-desc');

//         if(sortState === 0){
//             // malejąco
//             $rows.sort(function(a, b){
//                 var valA = parseFloat($(a).find('.loc__powl').text().replace(',', '.').match(/[\d\.]+/)[0]);
//                 var valB = parseFloat($(b).find('.loc__powl').text().replace(',', '.').match(/[\d\.]+/)[0]);
//                 return valB - valA;
//             });
//             $header.addClass('sort-desc');
//             sortState = 1;
//         } else if(sortState === 1){
//             // rosnąco
//             $rows.sort(function(a, b){
//                 var valA = parseFloat($(a).find('.loc__powl').text().replace(',', '.').match(/[\d\.]+/)[0]);
//                 var valB = parseFloat($(b).find('.loc__powl').text().replace(',', '.').match(/[\d\.]+/)[0]);
//                 return valA - valB;
//             });
//             $header.addClass('sort-asc');
//             sortState = 2;
//         } else {
//             // reset do pierwotnej kolejności
//             $rows = $(originalOrder);
//             sortState = 0;
//         }

//         $rows.each(function(){
//             $table.append(this);
//         });
//     });
// });
